import {useCallback} from 'react';
import {Conversation} from '@stripe-internal/conversations-client';
import {
  MessageFromParent,
  MessageFromParentType,
} from '../../Providers/ParentMessageBusProvider/MessageFromParent';
import {useParentMessageHandler} from '../../Providers/ParentMessageBusProvider';

export const useConversationContextHandoff = (conversation: Conversation) => {
  const handler = useCallback(
    (msg: MessageFromParent) => {
      if (msg.type === MessageFromParentType.ContextHandoff) {
        conversation.setContextValues(msg.context);
      }
    },
    [conversation],
  );

  useParentMessageHandler(handler);
};
